import { createNaturalArithmeticTask, randInt, simpleAdditionExplanation } from "./sharedNaturalArithmetic";

function pickData() {
  for (let i = 0; i < 300; i += 1) {
    const a = randInt(1, 8);
    const b = randInt(1, 8);
    if (a + b < 10) return { a, b, op: "+", result: a + b };
  }
  return { a: 7, b: 2, op: "+", result: 9 };
}

const mod = createNaturalArithmeticTask({
  type: "NaturalAddOneDigitNoCarryTask",
  pickData,
  explain: simpleAdditionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
